import React from 'react';
import { createContainer } from '@dbk-legacy/muster/react';
import Text from '@dbk/ui-text';
import {INVESTMENT_CONSTANTS} from '../../constants';

const SubInvestment = (props) => {

    const detectIE =()=> {
        let oReturn = false;
        const isIE = !!navigator.userAgent.match(/Trident/g) || !!navigator.userAgent.match(/MSIE/g);
        if(isIE){
          oReturn = true;
        }
        else{
          oReturn = false;
        }
        return oReturn;
      }
    

    const renderSubIteams = () => {
        let renderArray = []
        let backGroundColorIdeaType =""
        let teaserColor = ""
        renderArray = props.items.map((item)=>{
            backGroundColorIdeaType = item.ideaType === INVESTMENT_CONSTANTS.BUY ? "buy-color" :  item.ideaType === INVESTMENT_CONSTANTS.SELL ? "sell-color" : "switch-color"
            teaserColor =  item.read === INVESTMENT_CONSTANTS.READ ? "read-color": "unread-color"
            return(
                <div className={`sub-container column small-12 medium-up-6 large-3`} >
                    <a onClick={() =>   props.changePage({pathname: '/investments/details/' + item.articleId})} className="subcomponent-header" style={{backgroundColor:item.assetColorcode }}>
                        <div className="subcomponent-firstview">
                            <div className="subcomponet-assest">{item.assestType}</div>
                            <div className="subcomponent-ideatype">
                                <Text className={`text-ideatype ${backGroundColorIdeaType}`}>{item.ideaType}</Text>
                            </div>
                        </div>
                        <div className={detectIE()? `subcomponet-secondview-common subcomponet-secondview-ie-browser`:`subcomponet-secondview-common subcomponet-secondview-other`}>
                            <div className={`subcomponet-teaser`}>
                                <Text className={`subcomponet-text-teaser ${teaserColor}`}>
                                    {item.teaser}
                               </Text>
                            </div>
                            <div className="sub-dateview">
                                <Text className="text-subdate">
                                    {item.date}
                                </Text>
                            </div>
                        </div>
                    </a>
                </div>
            )
        })
        return renderArray;
    }

    
        return (
            <div className="row align-spaced">
                <div className="subinvestment-grid small-up-1 medium-up-2 large-up-4">
                  {renderSubIteams()}
                </div>
            </div>
        )

}

export default createContainer({
    $queries: {
        changePage: { 
            $call: 'ui.history.push' 
          },
          i18n: {
            messages: true,
          },
    },
})(SubInvestment);

